import { render, staticRenderFns } from "./file_viewer.vue?vue&type=template&id=f72ce51e&"
import script from "./file_viewer.vue?vue&type=script&lang=js&"
export * from "./file_viewer.vue?vue&type=script&lang=js&"
import style0 from "./file_viewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports